import styled from 'styled-components';
import { memo, MouseEvent } from 'react';
import diamondLoaderGrey from 'assets/images/diamonds-row-grey.gif';
import { useMixpanel, useLoading } from 'hooks';
import { ButtonDiamondsLoadingProps } from 'types/buttons';
import buttonStyle from './button-styles';

const StyledButton = memo(styled.button`
  ${buttonStyle}
`);

const InlineLoadingContent = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const Container = styled.div<{ isVertical: boolean }>`
  display: flex;
  flex-direction: ${props => (props.isVertical ? 'column' : 'row')};
  align-items: baseline;
`;

const LoadingContainer = styled.div<{ isVertical: boolean }>`
  ${props => props.isVertical && 'margin-top:10px;'}
  ${props => !props.isVertical && 'margin-left:10px;'}
  display: grid;
  align-items: baseline;
`;

const LoadingText = styled.text`
  font-size: 12px;
  margin-left: 12px;
  color: ${props => props.theme.colors.headerGrey};
`;
const ErrorText = styled.div<{ isClickable: boolean }>`
  font-size: 12px;
  margin-left: 12px;
  color: ${props => props.theme.colors.red};
  margin-top: 12px;
  cursor: ${props => (props.isClickable ? 'pointer' : 'default')};
`;

const Image = styled.img`
  height: 30px;
  width: 110px;
`;

export const ButtonDiamondsLoading = ({
  mixpanelProps,
  onClick,
  className,
  submit,
  children,
  ids,
  isLoading,
  disabled,
  isVertical = false,
  loadingText = '',
  errorText,
  onErrorClick,
  errorClickable = false,
  loadingInsideButton = false,
  hideLoadingIndicator = false,
  ...props
}: ButtonDiamondsLoadingProps) => {
  const { logToMixpanel, incrementPeople } = useMixpanel();
  const [checkIsLoading] = useLoading();

  const loading = isLoading || (ids && ids.length > 0 && checkIsLoading(ids));

  const onClickAction = (e: MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    }
    if (mixpanelProps && mixpanelProps.object) {
      logToMixpanel(mixpanelProps.object);
    }
    if (mixpanelProps && mixpanelProps.people) {
      incrementPeople(mixpanelProps.people as string);
    }
  };
  return (
    <Container isVertical={isVertical}>
      <StyledButton
        className={className}
        disabled={disabled || loading}
        type={submit ? 'submit' : 'button'}
        onClick={onClickAction}
        {...props}
      >
        {loading && loadingInsideButton && !hideLoadingIndicator ? (
          <InlineLoadingContent>
            <Image src={diamondLoaderGrey} alt="" />
          </InlineLoadingContent>
        ) : (
          children
        )}
      </StyledButton>
      {loading && !loadingInsideButton && !hideLoadingIndicator && (
        <LoadingContainer isVertical={isVertical}>
          <Image src={diamondLoaderGrey} alt="" />
          <LoadingText>{loadingText}</LoadingText>
        </LoadingContainer>
      )}
      {!loading && errorText && errorText !== '' && (
        <ErrorText onClick={onErrorClick} isClickable={errorClickable && !disabled}>
          {errorText}
        </ErrorText>
      )}
    </Container>
  );
};

export default ButtonDiamondsLoading;
